import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "maxLength", "tolerance", "showMoreLabel", "showLessLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextLink from 'components/TextLink';
import UserGeneratedText from 'components/UserGeneratedText';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function getLineBreakPosition(content) {
  var lineBreakIndex = content.indexOf('\n');
  if (lineBreakIndex === -1) return Infinity;
  return lineBreakIndex;
}
function ViewMoreText(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var content = props.content,
    maxLength = props.maxLength,
    _props$tolerance = props.tolerance,
    tolerance = _props$tolerance === void 0 ? 30 : _props$tolerance,
    _props$showMoreLabel = props.showMoreLabel,
    showMoreLabel = _props$showMoreLabel === void 0 ? t('actions_show_more') : _props$showMoreLabel,
    _props$showLessLabel = props.showLessLabel,
    showLessLabel = _props$showLessLabel === void 0 ? t('actions_show_less') : _props$showLessLabel,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFullText = _useState2[0],
    setShowFullText = _useState2[1];
  function toggleShowMore() {
    setShowFullText(function (prevState) {
      return !prevState;
    });
  }
  var contentLength = (content === null || content === void 0 ? void 0 : content.length) || 0;
  var maxLengthBeforeLineBreak = Math.min(maxLength, getLineBreakPosition(content));
  var shouldTextBeTruncated = contentLength > maxLengthBeforeLineBreak + tolerance;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UserGeneratedText, {
      text: content,
      truncateLength: !showFullText ? maxLengthBeforeLineBreak : 0,
      allowLineBreaks: !shouldTextBeTruncated || showFullText
    }), ' ', shouldTextBeTruncated && /*#__PURE__*/_jsx(TextLink, _objectSpread(_objectSpread({}, otherProps), {}, {
      as: "button",
      onClick: toggleShowMore,
      children: showFullText ? showLessLabel : showMoreLabel
    }))]
  });
}
export default ViewMoreText;